import React from "react";

import { ReactComponent as AboutLoungeIcon } from "../../../assets/svg/about_lounge.svg";
import startupGuideImg from "../../../assets/images/Manual/startup-guide_img.jpg";
import adminFeaturesImg from "../../../assets/images/Manual/admin-features_img.jpg";
import teachingFeaturesImg from "../../../assets/images/Manual/teaching-features_img.jpg";
import styles from "../Select.module.scss";

const MANUAL = [
  {
    img: startupGuideImg,
    link: "https://www.enageed.jp/hubfs/servicemanual/startup-guide-manual.pdf",
    label: "スタートアップガイド",
  },
  {
    img: adminFeaturesImg,
    link:
      "https://www.enageed.jp/hubfs/servicemanual/admin-features-manual.pdf",
    label: "学校管理機能マニュアル",
  },
  {
    img: teachingFeaturesImg,
    link:
      "https://www.enageed.jp/hubfs/servicemanual/teaching-features-manual.pdf",
    label: "授業用機能マニュアル",
  },
];

const Manual = () => {
  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.inner}>
            <p className={styles.title}>
              <AboutLoungeIcon width="25" height="18" />
              マニュアルを選んでください
            </p>
            <div className={styles.manual}>
              {MANUAL.map((manual, index) => (
                <div key={index} className={styles.link}>
                  <img
                    className={styles.img}
                    src={manual.img}
                    alt={manual.label}
                  />
                  <a
                    className={styles.button}
                    href={manual.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                      <polyline points="10 9 9 9 8 9" />
                    </svg>
                    {manual.label}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manual;
